import { render, staticRenderFns } from "./TicketClosingNote.vue?vue&type=template&id=66280614&scoped=true&"
import script from "./TicketClosingNote.vue?vue&type=script&lang=js&"
export * from "./TicketClosingNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66280614",
  null
  
)

export default component.exports